<template>
  <div class="download-content-wrapper">
    <h1 class="title">
      {{ $t("download.pageTitle") }}
    </h1>
    <section class="wrapper">
      <div class="student-wrap">
        <h3 class="app">
          {{ $t("download.studentApp") }}
        </h3>
        <h4 class="info">
          {{ $t("download.studentInfo") }}
        </h4>
        <div class="student-pic" />
        <div class="tab-header">
          <div class="custom_row" :gutter="10">
            <div v-for="(item, index) in ableTabs" :key="index" class="custom_col" :span="6">
              <template v-if="item.name == 'ipad' || item.name == 'android' || item.name == 'iPhone'">
                <el-popover
                  :key="index"
                  ref="popover"
                  popper-class="download-img-popover"
                  placement="top"
                  trigger="hover"
                >
                  <vue-qr
                    v-if="
                      item.name == 'android' && packageUrlObj[keys[item.name]]
                    "
                    :logo-src="studentLogo"
                    :text="packageUrlObj[keys[item.name]]"
                    :size="400"
                    :margin="15"
                  />
                  <img
                    v-if="item.name == 'ipad' || item.name == 'iPhone'"
                    class="qr-img"
                    :data-not-lazy="true"
                    v-lazy-load :data-src="require('assets/images/download/qr-student.png')"
                    alt="student-qr-code"
                  >
                  <div
                    slot="reference"
                    class="tab-item"
                    @click="handleClick(item)"
                  >
                    <i class="device_icon" :class="[item.title === 'iPhone'?'iphone':item.name]" />
                    <p>{{ item.title }}</p>
                  </div>
                </el-popover>
              </template>

              <template v-else>
                <div :key="item.name" class="tab-item" @click="handleClick(item)">
                  <i class="device_icon" :class="[item.name]" />
                  <p>{{ item.title }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="parent-wrap">
        <h3 class="app">
          {{ $t("download.parentApp") }}
        </h3>
        <h4 class="info">
          {{ $t("download.parentInfo") }}
        </h4>
        <div class="parent-pic" />
        <div class="tab-header">
          <div class="custom_row">
            <div v-for="item in parentTabs" :key="item.name" class="custom_col" :span="6">
              <el-popover
                popper-class="download-img-popover"
                placement="top"
                trigger="hover"
              >
                <img
                  v-if="item.name == 'iphoneParent'"
                  class="qr-img"
                  :data-not-lazy="true"
                  v-lazy-load :data-src="require('assets/images/download/qr-parent.png')"
                  alt="qr-parent"
                >
                <vue-qr
                  v-if="
                    item.name == 'androidParent' && packageUrlObj[keys[item.name]]
                  "
                  :logo-src="parentLogo"
                  :text="packageUrlObj[keys[item.name]]"
                  :size="400"
                  :margin="15"
                />
                <div slot="reference" class="tab-item" @click="handleClick(item)">
                  <i
                    class="device_icon"
                    :class="[item.name.replace('Parent', '')]"
                  />
                  <p>{{ item.title }}</p>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </section>
    <h1 class="title">
      {{ $t("download.deviceTitle") }}
    </h1>
    <ul class="info-content">
      <li class="info-item">
        <div class="icon windows" />
        <div class="fenge" />
        <dl class="list-info">
          <dt>{{ $t("download.windowsRequirement.title") }}</dt>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.windowsRequirement.info1") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.windowsRequirement.info2") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.windowsRequirement.info3") }}</p>
          </dd>
        </dl>
      </li>
      <li class="info-item">
        <div class="icon mac" />
        <div class="fenge" />
        <dl class="list-info">
          <dt>{{ $t("download.macRequirement.title") }}</dt>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.macRequirement.info1") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.macRequirement.info2") }}</p>
          </dd>
        </dl>
      </li>
      <li class="info-item">
        <div class="icon ipad" />
        <div class="fenge" />
        <dl class="list-info">
          <dt>{{ $t("download.ipadRequirement.title") }}</dt>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.ipadRequirement.info1") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.ipadRequirement.info2") }}</p>
          </dd>
        </dl>
      </li>
      <li class="info-item">
        <div class="icon iphone" />
        <div class="fenge" />
        <dl class="list-info">
          <dt>{{ $t("download.iphoneRequirement.title") }}</dt>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.iphoneRequirement.info1") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.iphoneRequirement.info2") }}</p>
          </dd>
        </dl>
      </li>
      <li class="info-item">
        <div class="icon android" />
        <div class="fenge" />
        <dl class="list-info">
          <dt>{{ $t("download.androidRequirement.title") }}</dt>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.androidRequirement.info1") }}</p>
          </dd>
          <dd>
            <span class="circle" />
            <p>{{ $t("download.androidRequirement.info2") }}</p>
          </dd>
        </dl>
      </li>
    </ul>
    <ConfirmDialog :show.sync="show" :show-main-btn="true" main-btn-text="OK">
      <template v-slot:content>
        <div class="contact-dialog-body prevent-content">
          <h2><i class="iconfont icon-info-circle" /> Device Not Compatible</h2>
          <p>
            Sorry, your device is not supported. Please download the software on
            devices that meet the minimum requirements.
          </p>
        </div>
      </template>
    </ConfirmDialog>
  </div>
</template>
<script>
import { overseaApi } from 'config/api';
import config from './config.js';
import {
  getSystemType,
  getSystemVersion,
  getClientDeviceType,
} from 'common/utils.js';
import VueQr from 'vue-qr';
import ConfirmDialog from 'components/common/ConfirmDialog/index.vue';

const parentLogo = require('assets/images/my-courses/parent-app-logo-1.jpg');
const studentLogo = require('assets/images/my-courses/app-logo-1.jpg');

export default {
  components: {
    ConfirmDialog,
    VueQr,
  },
  asyncData({ req }) {
    const userAgent = process.server
      ? req.headers['user-agent']
      : navigator.userAgent;
    const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    const isIOS = !!userAgent.match(/Mac OS X/);
    const isPad = userAgent.indexOf('iPad') > -1;
    const isWeixin = userAgent.toLocaleLowerCase().includes('micromessenger');

    const appStoreDownloadUrl = 'https://apps.apple.com/cn/app/think-academy-classroom/id1531693338';
    const downloadUrl = isIOS ? appStoreDownloadUrl : '';
    return {
      isIOS,
      isAndroid,
      isPad,
      downloadUrl,
      isWeixin,
    };
  },
  data() {
    return {
      parentLogo,
      studentLogo,
      shell: {},
      showStop: false,
      show: false,
      prevent: false,
      locale: this.$store.state.locale,
      defaultSystem: 'windows',
      system: '',
      loading: false,
      download_url: '',
      keys: config.keys,
      // paramsKeys: config.paramsKeys,
      version: '',
      ableTabs: this.$t('download.ableTabs'),
      parentTabs: this.$t('download.parentTabs'),
      androidTabletStudentUrl: '',
      androidParentUrl: '',
      packageUrlObj: {},
    };
  },
  computed: {
    sysType() {
      return getSystemType();
    },
  },
  async mounted() {
    this.system = getClientDeviceType();
    if (this.sysType === 'mac') {
      this.system = 'mac';
      this.defaultSystem = 'mac';
    }
    // this.initData(this.keys[this.defaultSystem]);
    if (this.defaultSystem === 'mac') {
      const version = getSystemVersion().split('.');
      if (version[0] < 10 || (version[0] === 10 && version[1] < 12)) {
        this.prevent = true;
      }
    }
    if (this.defaultSystem === 'windows') {
      if (getSystemVersion() >= 6.1) {
        this.prevent = false;
      } else {
        this.prevent = true;
      }
    }
    await this.initData(this.keys.android);
    await this.initData(this.keys.androidParent); // androidParent
  },
  methods: {
    async initData(val) {
      this.loading = true;
      const data = { clientType: val };
      const res = await this.$axios.post(overseaApi.getUpgrade, data, {
        rewritePostBody: false,
      });
      if (Number(res.stat) !== 1) {
        this.$ElMessage.error(res.msg);
        this.loading = false;
        return;
      }
      this.version = res.data.newVersion;
      this.download_url = res.data.packageUrl;
      this.$set(this.packageUrlObj, val, res.data.packageUrl);
      this.loading = false;
    },
    async handleClick(val) {
      this.defaultSystem = val.name;
      this.system = val.name;
      if (
        this.prevent
        && (this.system === 'mac' || this.system === 'windows')
      ) {
        this.show = true;
        return;
      }
      if (this.system === 'windows' || this.system === 'mac') {
        await this.initData(this.keys[val.name]);
        window.open(this.packageUrlObj[this.keys[val.name]], '_blank');
      }
    },
    getClientType() {
      if (this.isIOS) {
        if (this.isPad) {
          return 'ipad';
        }
        return 'iphone';
      }
      return 'android';
    },
  },
};
</script>
<style lang="scss" scoped>
.download-content-wrapper {
  h1.title {
    color: --txt-color-lv1;
    font-size: 40px;
    text-align: center;
    margin: 80px auto 40px auto;
    font-weight: bold;
  }

  .wrapper {
    display: flex;
    gap: 65px;

    .student-wrap,
    .parent-wrap {
      width: 590px;
    }

    .app {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .info {
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 17px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 3em;
      height: 42px;
    }

    .parent-pic {
      width: 590px;
      height: 415px;
      background:
        center/100% no-repeat
        url("~assets/images/download/parent-app.png");
    }

    .student-pic {
      height: 415px;
      background:
        center/100% no-repeat
        url("~assets/images/download/student-app.png");
    }
  }

  .tab-header {
    margin: 17px 0 0 0;

    .custom_row {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .tab-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 138px;
      height: 40px;
      border: 1px solid rgba(34, 34, 34, 0.4);
      color: #222;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;

      .mark {
        font-size: 12px;
      }

      .device_icon {
        display: block;
        width: 14px;
        height: 14px;
        margin-right: 3px;
      }

      .device_icon.iphone {
        background:
          url("~assets/images/download/button/iphone-black.png")
          no-repeat;
        background-size: 100%;
      }

      .device_icon.android {
        background:
          url("~assets/images/download/button/android-black.png")
          no-repeat;
        background-size: 100%;
      }

      .device_icon.windows {
        background:
          url("~assets/images/download/button/windows-black.png")
          no-repeat;
        background-size: 100%;
      }

      .device_icon.mac {
        background:
          url("~assets/images/download/button/mac-black.png")
          no-repeat;
        background-size: 100%;
      }

      .device_icon.ipad {
        background:
          url("~assets/images/download/button/ipad-black.png")
          no-repeat;
        background-size: 100%;
      }

      &:nth-last-child(1) {
        margin: 0;
      }

      &.active {
        background: var(--txt-color-link);
        color: #fff;
        border: 0 none;

        &:hover {
          background: var(--txt-color-link);
        }

        .device_icon.iphone {
          background:
            url("~assets/images/download/button/iphone-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.android {
          background:
            url("~assets/images/download/button/android-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.windows {
          background:
            url("~assets/images/download/button/download-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.mac {
          background:
            url("~assets/images/download/button/download-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.ipad {
          background:
            url("~assets/images/download/button/ipad-orange.png")
            no-repeat;
          background-size: 100%;
        }
      }

      &:hover {
        border: 0 none;
        background: #ffaa0a;
        color: #fff;

        .device_icon.iphone {
          background:
            url("~assets/images/download/button/iphone-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.android {
          background:
            url("~assets/images/download/button/android-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.windows {
          background:
            url("~assets/images/download/button/download-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.mac {
          background:
            url("~assets/images/download/button/download-orange.png")
            no-repeat;
          background-size: 100%;
        }

        .device_icon.ipad {
          background:
            url("~assets/images/download/button/ipad-orange.png")
            no-repeat;
          background-size: 100%;
        }
      }
    }

    // &::after {
    //   display: block;
    //   content: '';
    //   clear: both;
    //   height: 0;
    // }
  }

  .info-content {
    margin-bottom: 80px;
    display: flex;
    gap: 22px;
    justify-content: center;
    padding: 0;

    .info-item {
      box-shadow: 0 5px 18px 7px rgba(122, 122, 122, 0.06);
      border-radius: 10px;
      padding: 30px 16px 16px 16px;
      width: 232px;
      list-style: none;

      .icon {
        margin: 0 auto;
        width: 60px;
        height: 60px;

        &.windows {
          background:
            center/100% no-repeat
            url("~assets/images/download/windows.png");
        }

        &.mac {
          background:
            center/100% no-repeat
            url("~assets/images/download/mac.png");
        }

        &.android {
          background:
            center/100% no-repeat
            url("~assets/images/download/android.png");
        }

        &.ipad {
          background:
            center/100% no-repeat
            url("~assets/images/download/ipad.png");
        }

        &.iphone {
          background:
            center/100% no-repeat
            url("~assets/images/download/iphone.png");
        }
      }

      .fenge {
        margin: 30px 0;
        border-top: 1px solid rgba(34, 34, 34, 0.1);
      }

      .list-info {
        dt {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 12px;
        }

        dd {
          color: var(--txt-color-lv2);
          font-size: 14px;
          margin-bottom: 8px;

          p {
            display: inline-block;
            width: 190px;
            vertical-align: top;
          }

          .circle {
            display: inline-block;
            width: 5px;
            height: 5px;
            background-color: var(--txt-color-link);
            border-radius: 50%;
            margin-right: 5px;
            vertical-align: 3px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.download-img-popover {
  min-width: auto;
  padding: 8px;

  img {
    width: 124px;
    height: 124px;
  }
}
</style>
